/**
 * 城里这一圈的家什：店铺的柜台货架、干活的工作点、买卖用的摊子、
 * 还有衙门那些只给人看的摆设。
 *
 * interact.action = 'shop'   -> 打开这家铺子的面板（state.shop 指名是谁家）
 * interact.action = 'board'  -> 打开告示榜 / 委托榜
 * interact.action = 'window' -> 打开证照窗口
 * interact.action = 'stall'  -> 摊位与地块
 * interact.action = 'hire'   -> 雇工 / 派遣
 */

/** 柜台与货架：每家铺子的脸面 */
export const SHOP_PROPS = {
  shop_counter: {
    name: '柜台', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '柜台', hint: 'E 买卖' },
    desc: '掌柜的把手肘搁在上面。', state: { shop: 'general' },
  },
  notice_board: {
    name: '告示榜', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'board', label: '告示榜', hint: 'E 看榜' },
    desc: '新告示压着旧的，边角都卷了。',
  },
  license_window: {
    name: '证照窗口', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'window', label: '证照窗口', hint: 'E 办事' },
    desc: '一个小窗口，里头的吏连头都不抬。',
  },
  license_frame: {
    name: '张贴核准名录的木框', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'window', label: '核准名录', hint: 'E 看看' },
    desc: '谁批了、批给谁，都抄在这儿。',
  },
  market_stall: {
    name: '摊位', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'stall', label: '摊位', hint: 'E 看看地皮' },
    desc: '别人的地盘，摆货要交租。',
  },
  hire_post: {
    name: '雇工的短工市', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'hire', label: '短工市', hint: 'E 找人干活' },
    desc: '一大早蹲着一排等活的人。',
  },
  government_desk: {
    name: '衙署公案', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'window', label: '衙署公案', hint: 'E 办事' },
    desc: '案上堆着卷宗。',
  },
  government_office: {
    name: '衙门', w: 3, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'window', label: '衙门', hint: 'E 进门办事' },
    desc: '朱漆大门，门口两只石狮子。',
  },
  cargo_office: {
    name: '货栈柜房', w: 3, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'quest', label: '货栈柜房', hint: 'E 看委托' },
    desc: '墙上挂着水牌，写着谁要什么货。',
  },
  stage: {
    name: '戏台', w: 3, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'board', label: '戏台', hint: 'E 听听' },
    desc: '台口支着两根柱子，幔子褪了色。',
  },
  sealed_desk: {
    name: '查封的公案', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'window', label: '查封的公案', hint: 'E 看看封条' },
    desc: '两条封纸交叉贴着，印还清楚。',
  },
  magistrate_seat: {
    name: '县尊座', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'sit', label: '县尊座', hint: 'E 坐一坐' },
    desc: '坐上去往后一靠，说话就有底气。',
  },
  locked_ledger: {
    name: '锁着的账册', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'read', label: '账册', hint: 'E 翻一翻' },
    desc: '铜扣扣着，翻之前得挑开。',
  },
  ledger_shelf: {
    name: '账册架', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'read', label: '账册架', hint: 'E 翻一翻' },
    desc: '一年一摞，摞得整整齐齐。',
  },
  spring_scale: {
    name: '弹簧秤', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '弹簧秤', hint: 'E 称一称' },
    desc: '称小件好用，压重了就不准。',
  },
  cargo_scale: {
    name: '磅秤', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '磅秤', hint: 'E 称一称' },
    desc: '一块厚木台，底下四个铁轮子。',
  },
  junkyard_scale: {
    name: '收购站的大秤', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '大秤', hint: 'E 过秤' },
    desc: '秤砣比脑袋大，秤杆上全是刻痕。', state: { shop: 'junkyard' },
  },
  water_well: {
    name: '水井', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'draw', label: '水井', hint: 'E 取水' },
    desc: '井沿磨得溜光。',
  },
  pump_well: {
    name: '压水井', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'draw', label: '压水井', hint: 'E 压水' },
    desc: '压几下就出水，省力。',
  },
  water_trough: {
    name: '水槽', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'draw', label: '水槽', hint: 'E 舀水' },
    desc: '牲口和人都在里头喝水。',
  },
  washtub: {
    name: '洗衣盆', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'wash', label: '洗衣盆', hint: 'E 洗一洗' },
    desc: '搓衣板斜搭在盆沿上。',
  },
  bathtub: {
    name: '浴桶', w: 2, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'bathe', label: '浴桶', hint: 'E 泡一泡' },
    desc: '水面上浮着一层薄薄的热气。',
  },
};

/** 干活的工作点：都在匠作 appropriate 场地里 */
export const CRAFT_PROPS = {
  simple_stove: {
    name: '简易炉灶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'cook', label: '简易炉灶', hint: 'E 炊事' },
    desc: '三块砖一架就能烧火。',
  },
  tiled_stove: {
    name: '柴灶', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'cook', label: '柴灶', hint: 'E 炊事' },
    desc: '灶膛里的火苗舔着锅底。',
  },
  steamer_stack: {
    name: '蒸笼', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'cook', label: '蒸笼', hint: 'E 炊事' },
    desc: '一层一层摞着，揭一层香一层。',
  },
  bamboo_steamer: {
    name: '竹屉', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'cook', label: '竹屉', hint: 'E 炊事' },
    desc: '竹香混着面香。',
  },
  noodle_stand: {
    name: '面档', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '面档', hint: 'E 买卖' },
    desc: '案板上一层面粉，面条码得齐整。', state: { shop: 'eatery' },
  },
  drying_rack: {
    name: '晾晒架', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'tend', label: '晾晒架', hint: 'E 翻晒' },
    desc: '半干的药材摊在上面。',
  },
  quern: {
    name: '石磨', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'assemble', label: '石磨', hint: 'E 推磨' },
    desc: '推一圈就吱呀一声。',
  },
  manual_grindstone: {
    name: '手摇磨', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'assemble', label: '手摇磨', hint: 'E 磨一磨' },
    desc: '磨豆子、磨药都行。',
  },
  iron_anvil: {
    name: '铁砧', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'assemble', label: '铁砧', hint: 'E 打铁' },
    desc: '砧面凹下去一小块。',
  },
  forging_stove: {
    name: '打铁炉', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'assemble', label: '打铁炉', hint: 'E 动手' },
    desc: '风箱一拉，火星子往上窜。',
  },
  tool_rack: {
    name: '工具架', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '工具架', hint: 'E 取用' },
    desc: '锤子、锉子、锯子各归各位。',
  },
  carpentry_workbench: {
    name: '木工案子', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'assemble', label: '木工案子', hint: 'E 动手做活' },
    desc: '案面上还留着上一件的墨线。',
  },
  counts_frame: {
    name: '计数架', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '计数架', hint: 'E 记一笔' },
    desc: '一格一记号，数完才知道今天收了多少。',
  },
};

/** 店铺里的陈设与家什 */
export const SHOP_FURNITURE = {
  grocery_shelf: {
    name: '杂货架', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '杂货架', hint: 'E 买卖' },
    desc: '油盐酱醋摆了两层。', state: { shop: 'general' },
  },
  earthenware_shelf: {
    name: '陶器架', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '陶器架', hint: 'E 买卖' },
    desc: '碗碟摞得小心翼翼。', state: { shop: 'general' },
  },
  multi_tier_shelf: {
    name: '多层货架', w: 2, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '多层货架', hint: 'E 存取' },
    desc: '越高层越没人动。',
  },
  warehouse_shelves: {
    name: '仓库货架', w: 2, h: 2, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '仓库货架', hint: 'E 存取' },
    desc: '货架顶到房梁。',
  },
  part_shelf: {
    name: '零件架', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '零件架', hint: 'E 买卖' },
    desc: '一格一种，标着歪歪扭扭的字。', state: { shop: 'garage' },
  },
  parts_cabinet: {
    name: '零件柜', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '零件柜', hint: 'E 买卖' },
    desc: '抽屉一拉哗啦响。', state: { shop: 'garage' },
  },
  medicine_cabinet: {
    name: '药柜', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '药柜', hint: 'E 买卖' },
    desc: '一整面墙的小抽屉。', state: { shop: 'pharmacy' },
  },
  herb_cabinet: {
    name: '草药抽屉柜', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '草药柜', hint: 'E 买卖' },
    desc: '每格一种草，味混在一起。', state: { shop: 'pharmacy' },
  },
  bookcase: {
    name: '书架', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'bookshelf', label: '书架', hint: 'E 翻书' },
    desc: '书脊都磨白了。',
  },
  locked_glass_bookcase: {
    name: '玻璃书柜', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '玻璃书柜', hint: 'E 买卖' },
    desc: '锁着，隔着玻璃也能看出贵。', state: { shop: 'library' },
  },
  medical_book_pile: {
    name: '医书摞', w: 1, h: 1, solid: false, layer: 'floor',
    interact: { action: 'read', label: '医书摞', hint: 'E 翻一翻' },
    desc: '边上全是批注。',
  },
  salt_vat: {
    name: '盐缸', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '盐缸', hint: 'E 买卖' },
    desc: '缸沿结着一层白霜。', state: { shop: 'general' },
  },
  oil_vat: {
    name: '油缸', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '油缸', hint: 'E 买卖' },
    desc: '打油的长柄勺斜插着。', state: { shop: 'general' },
  },
  sauce_jar_tower: {
    name: '酱缸塔', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '酱缸塔', hint: 'E 买卖' },
    desc: '缸口盖着竹编的盖。', state: { shop: 'eatery' },
  },
  locked_box: {
    name: '锁着的匣子', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '匣子', hint: 'E 存取' },
    desc: '钥匙在掌柜腰上挂着。',
  },
  chest_labeled: {
    name: '贴签的木箱', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '木箱', hint: 'E 存取' },
    desc: '签子上写着里头是什么。',
  },
  long_table: {
    name: '长条桌', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'sit', label: '长条桌', hint: 'E 坐下' },
    desc: '几条长凳对着摆。',
  },
  dining_table: {
    name: '饭桌', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'sit', label: '饭桌', hint: 'E 坐下' },
    desc: '桌面上一圈油渍。',
  },
  gambling_mat: {
    name: '赌席', w: 2, h: 1, solid: false, layer: 'floor',
    interact: { action: 'sit', label: '赌席', hint: 'E 坐下试试' },
    desc: '骰子碗扣在席子中间。',
  },
  storyteller_table: {
    name: '说书案', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'sit', label: '说书案', hint: 'E 坐下听' },
    desc: '醒木一拍，满堂静。',
  },
  changing_bench: {
    name: '更衣长凳', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'sit', label: '更衣长凳', hint: 'E 坐下' },
    desc: '衣裳搭在这儿，回来还在。',
  },
  guest_futon: {
    name: '通铺', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'sleep', label: '通铺', hint: 'E 歇一夜' },
    desc: '挨着睡的陌生人，天亮各自走。',
  },
  simple_sickbed: {
    name: '诊床', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'sleep', label: '诊床', hint: 'E 躺一会儿' },
    desc: '薄薄一层褥子。',
  },
  incense_burner: {
    name: '香炉', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'meditate', label: '香炉', hint: 'E 静一静' },
    desc: '一炉香能压住半屋子味。',
  },
  liquor_flag: {
    name: '酒望子', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '酒望子', hint: 'E 买卖' },
    desc: '一面布幌子，风一吹哗啦响。', state: { shop: 'fun_room' },
  },
  agent_desk: {
    name: '揽货的桌子', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'quest', label: '揽货处', hint: 'E 看委托' },
    desc: '水牌上写着今日的活。',
  },
};

/** 露天的摊子与地里的东西 */
export const OUTDOOR_PROPS = {
  flat_fruit_vendor: {
    name: '趴活水果摊', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '水果摊', hint: 'E 买卖' },
    desc: '半车果子，卖相一般但便宜。', state: { shop: 'general' },
  },
  water_bladder_vendor: {
    name: '水囊摊子', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '水囊摊子', hint: 'E 买卖' },
    desc: '走远路的人都要在这儿补水。', state: { shop: 'general' },
  },
  jelly_ball_stall: {
    name: '凉粉摊', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '凉粉摊', hint: 'E 买卖' },
    desc: '一碗下去透心凉。', state: { shop: 'eatery' },
  },
  pumpkin_land: {
    name: '南瓜地', w: 2, h: 2, solid: false, layer: 'floor',
    interact: { action: 'forage', label: '南瓜地', hint: 'E 采摘' },
    desc: '叶子底下藏着一个个滚圆的瓜。',
  },
  sunflower_field: {
    name: '向日葵地', w: 2, h: 2, solid: false, layer: 'floor',
    interact: { action: 'forage', label: '向日葵地', hint: 'E 采摘' },
    desc: '全都朝着一个方向。',
  },
  seedling_tray: {
    name: '育苗盘', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'tend', label: '育苗盘', hint: 'E 料理' },
    desc: '一格一棵，刚冒头。',
  },
  hay_pile: {
    name: '草料堆', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'forage', label: '草料堆', hint: 'E 抱一抱' },
    desc: '扎人，但牲口爱吃。',
  },
  animal_feed_sack: {
    name: '饲料袋', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '饲料袋', hint: 'E 买卖' },
    desc: '袋口敞着，伸手就能抓一把。', state: { shop: 'pet_shop' },
  },
  stable_fence: {
    name: '牲口栏', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '牲口栏', hint: 'E 看看牲口' },
    desc: '木头被牲口啃出牙印。', state: { shop: 'pet_shop' },
  },
  feed_trough: {
    name: '料槽', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'tend', label: '料槽', hint: 'E 添料' },
    desc: '槽底还剩一层碎料。',
  },
  pet_cage: {
    name: '兽笼', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'shop', label: '兽笼', hint: 'E 看看活物' },
    desc: '里头的活物眼睛亮亮的。', state: { shop: 'pet_shop' },
  },
  straw_mat: {
    name: '草席', w: 2, h: 1, solid: false, layer: 'floor',
    interact: { action: 'sleep', label: '草席', hint: 'E 将就一夜' },
    desc: '铺哪儿都能睡。',
  },
  sandbag: {
    name: '沙袋', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'store', label: '沙袋', hint: 'E 搬开' },
    desc: '防洪用的，早就晒得发白。',
  },
  firewood_pile: {
    name: '柴火垛', w: 2, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'forage', label: '柴火垛', hint: 'E 抱柴' },
    desc: '码得整整齐齐，抽一根就塌。',
  },
  refuse_bin: {
    name: '秽物桶', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '秽物桶', hint: 'E 翻找' },
    desc: '连野狗都不愿意靠近。', state: { parent: '泔水桶', dirty: 4, stink: 5 },
  },
  waste_bin: {
    name: '垃圾筐', w: 1, h: 1, solid: true, layer: 'furniture',
    interact: { action: 'scavenge', label: '垃圾筐', hint: 'E 翻找' },
    desc: '柳条编的，破了两个洞。', state: { parent: '垃圾桶', dirty: 2, stink: 2 },
  },
};
